export const setTransactionDetails = (transaction) => ({
  type: 'BT_DEPOSITACCOUNTS_SET_DETAILS',
  transaction
});

export const clearTransactionDetails = () => ({
  type: 'BT_DEPOSITACCOUNTS_CLEAR_DETAILS'
});
